module.exports = __webpack_public_path__ + "img/icon.64d6f15.png";